<div class="invoices-date-selector">
    <p>Selecciona la fecha inicial</p>
    <input type="date" [(ngModel)]="date">
    <button class="principal_button" (click)="FechaSeleccionada()">Seleccionar</button>
</div>